/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     路由入口
  +--------------------------------------------------------------------------------------
*/

import Vue from 'vue'
import Router from 'vue-router'

// 导入静态路由配置
import staticRoutes from './staticRoutes'
Vue.use(Router)
export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: staticRoutes
})
